import React from "react";
import {UpdateInvoicePaymentSettings} from "./UpdateInvoicePaymentSettings";

export const InvoicePaymentSettingsPage = function (props) {
    return (
        <div className="common-form-page invoice-payment-settings-page">
            <div className="common-form-page-header">
                <div className="common-form-page-header-content">
                    <div className="common-form-page-header-content-left">
                        <div className="common-form-page-header-text">
                            Stripe ↔ QBO Invoice Payment Settings
                        </div>
                    </div>
                </div>
            </div>
            <div className="common-form-page-content">
                <UpdateInvoicePaymentSettings/>
            </div>
        </div>
    );
}
